import React, { memo } from 'react'

import TableCell from '../../commons/TableCell'
import ResultsTable from '../../ResultsTable'

const FunctionalityTable = ({
   isSearch,
   order,
   functionalities,
   searchFunctionalitites,
   actionEdit,
   cleanCallback
}) => {
   const columns = [
      {
         title: 'NOMBRE DEL BUCKET',
         field: 'name',
         align: 'center',
         sorting: !!isSearch,
         customSort: () => 0,
         defaultSort: order,
         render: rowData => <TableCell text={rowData?.name} />
      },
      {
         title: 'DESCRIPCIÓN',
         field: 'description',
         align: 'center',
         sorting: false,
         render: rowData => <TableCell text={rowData?.description} />
      },
      {
         title: 'NOMBRE DEL APLICATIVO',
         field: 'applicationName',
         align: 'center',
         sorting: false,
         render: rowData => <TableCell text={rowData?.applicationName} />
      },
      {
         title: 'NOTIFICACIONES',
         field: 'isnotified',
         sorting: false,
         align: 'center'
      },
      {
         title: 'CÓDIGO BUCKET',
         field: 'uuid',
         sorting: false,
         align: 'center'
      }
   ]

   return (
      <ResultsTable
         columns={columns}
         tableData={functionalities}
         isSearch={isSearch}
         searchCallback={searchFunctionalitites}
         cleanCallback={cleanCallback}
         actionEdit={actionEdit}
         order={order}
         onlyTable={true}
         customActions={[]}
      />
   )
}

export default memo(FunctionalityTable)
